import React, { FC, useState, useEffect } from 'react';
import { db } from "../../firebase/firebase-core";

import {
  collection,
  getDocs,
  orderBy,
  where,
  query,
  loadBundle,
  limit,
} from "firebase/firestore";
import LocationViewer, { Coordinate } from '../LocationViewer/LocationViewer';

interface Infraction {
  id: string;
  description: string;
  licensePlate: string;
  latitude: number;
  longitude: number;
  timeStamp: string;
  userEmail: string;
  count?: 0;
}

const Infractions: FC = () => {
  const rowsLimit: number = 100;
  const [infractions, setInfractions] = useState<Infraction[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [messageTop, setMessageTop] = useState<string>(`Últimos ${rowsLimit} registros`)
  const [coordinatesInfraction, setCoordinatesInfraction] = useState<Coordinate[]>([]);

  const dateFomatted = (date: Date) => {
    let dateDay = `${date.getDate()}/${date.getMonth() + 1
      }/${date.getFullYear()}`;

    let hours = `${padZeroLeft(date.getHours())}: ${padZeroLeft(
      date.getMinutes()
    )}: ${padZeroLeft(date.getSeconds())}`;

    return dateDay + " - " + hours;
  };

  const padZeroLeft = (value: number): String => {
    return value < 10 ? `0${value}` : value.toString();
  };

  const getGoogleMapsLink = (latitude: number, longitude: number) => {
    //https://www.google.com/maps/search/?api=1&query=<lat>,<lng>
    return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  };

  useEffect(() => {
    async function load() {
      const querySnapshot = await getDocs(
        query(collection(db, "infractions"), orderBy("timeStamp", "desc"))
      );

      const queryUsers = await getDocs(collection(db, "users"));
      let infractionsList: Infraction[] = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();

        const user = queryUsers.docs.find((_) => _.data().uId === data.uId);
        const email = user != null ? user.data().email : "N/I";
        const date = new Date(data.timeStamp.seconds * 1000);

        infractionsList.push({
          id: doc.id,
          description: data.description,
          licensePlate: data.licensePlate,
          latitude: data.latitude,
          longitude: data.longitude,
          timeStamp: dateFomatted(date),
          userEmail: email,
        });
      });
      setInfractions(infractionsList);
      setLoading(false);

      const coor = infractionsList.map(obj => ({ lat: obj.latitude, lng: obj.longitude, count: 0 }));      
      const uniqueCoordinates = coor.map(coordinate => {
        const existingObj = coor.filter(item => item.lat === coordinate.lat && item.lng === coordinate.lng);
        let count = 1;
        if (existingObj && existingObj.length > 1) {
          count = existingObj.length;
        }
        return {
          ...coordinate,
          count: count,
        }
      });

      const uniqueArray = uniqueCoordinates.filter(
        (item, index, self) =>
          index === self.findIndex((obj) => obj.lat === item.lat && obj.lng === item.lng)
      );

      console.log("MAP_DATA", uniqueArray);
      setCoordinatesInfraction(uniqueArray);
    }
    load();
  }, []);

  console.log("Renderizou");

  return (
    <div style={{ display: "flex", margin: "1rem", flexDirection: 'column' }}>


      <LocationViewer coordinates={coordinatesInfraction} />
      {/* <h3 style={{ textAlign: 'center', color: 'gray' }}>{messageTop}</h3> */}
      <table>
        <thead>
          <tr>
            <th>DATA</th>
            <th>USUÁRIO</th>
            <th>PLACA</th>
            <th>INFRAÇÃO</th>
            <th>LOCAL</th>
          </tr>
        </thead>

        <tbody>
          {loading && (
            <tr>
              <td> Aguarde, carregando dados...</td>
            </tr>
          )}

          {!loading && infractions && infractions.length === 0 && (
            <tr>
              <td> Nenhum registro encontrado</td>
            </tr>
          )}

          {infractions &&
            infractions.map((infraction) => (
              <tr key={infraction.id}>
                <td>
                  <b>{infraction.timeStamp}</b>
                  <br />
                  <small>{infraction.id}</small>
                </td>
                <td style={{ width: "1%" }}>
                  {infraction.userEmail}
                </td>
                <td style={{ textAlign: "center", fontSize: "16px" }}>
                  {infraction.licensePlate}
                </td>
                <td>{infraction.description}</td>

                <td style={{ textAlign: "center", fontSize: "12px" }}>
                  <a
                    target="_blank"
                    href={getGoogleMapsLink(
                      infraction.latitude,
                      infraction.longitude
                    )}
                    title="Ver no google maps"
                  >
                    <div>
                      <img
                        width={10}
                        src="/maps_icon.png"
                        alt="google maps icon"
                      />
                      <br />
                      <small>
                        LAT: <b>{infraction.latitude}</b>
                        <br />
                        LON: <b>{infraction.longitude}</b>
                      </small>
                    </div>
                  </a>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Infractions
